import { interopDefault } from '~/router/utils'

export default [
  {
    name: '__facebook_deletion_status',
    path: '/facebook/deletion-status/',
    component: () =>
      interopDefault(
        import(
          '~/pages/car/users/facebook-deletion-status.vue' /* webpackChunkName: "pages-car-users-facebook-deletion-status.vue" */
        )
      ),
    meta: { noFooter: true }
  }
]
